"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FaqList = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/domains/faq/faq-item");
/**
 * 자주 묻는 질문 목록. 항목의 간격과 목록 role을 소유한다.
 */
let FaqList = class FaqList extends lit_1.LitElement {
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('role', 'list');
    }
    render() {
        return (0, lit_1.html) `
      <slot @slotchange=${this.handleSlotChange}></slot>
    `;
    }
    handleSlotChange() {
        this.items.forEach(item => item.setAttribute('role', 'listitem'));
    }
};
FaqList.styles = (0, lit_1.css) `
    :host {
      display: flex;
      flex-direction: column;
      gap: var(--space-1);
    }
  `;
__decorate([
    (0, decorators_js_1.queryAssignedElements)({ flatten: true })
], FaqList.prototype, "items", void 0);
FaqList = __decorate([
    (0, decorators_js_1.customElement)('mm-faq-list')
], FaqList);
exports.FaqList = FaqList;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmFxLWxpc3QuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJmYXEtbGlzdC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSw2QkFBMkM7QUFDM0MscURBQXdFO0FBRXhFLDZDQUEwQztBQUUxQzs7R0FFRztBQUVJLElBQU0sT0FBTyxHQUFiLE1BQU0sT0FBUSxTQUFRLGdCQUFVO0lBVXJDLGlCQUFpQjtRQUNmLEtBQUssQ0FBQyxpQkFBaUIsRUFBRSxDQUFBO1FBQ3pCLElBQUksQ0FBQyxZQUFZLENBQUMsTUFBTSxFQUFFLE1BQU0sQ0FBQyxDQUFBO0lBQ25DLENBQUM7SUFFRCxNQUFNO1FBQ0osT0FBTyxJQUFBLFVBQUksRUFBQTswQkFDVyxJQUFJLENBQUMsZ0JBQWdCO0tBQzFDLENBQUE7SUFDSCxDQUFDO0lBRU8sZ0JBQWdCO1FBQ3RCLElBQUksQ0FBQyxLQUFLLENBQUMsT0FBTyxDQUFDLElBQUksQ0FBQyxFQUFFLENBQUMsSUFBSSxDQUFDLFlBQVksQ0FBQyxNQUFNLEVBQUUsVUFBVSxDQUFDLENBQUMsQ0FBQTtJQUNuRSxDQUFDOztBQXRCTSxjQUFNLEdBQUcsSUFBQSxTQUFHLEVBQUE7Ozs7OztHQU1sQixDQUFBO0FBQ3lDO0lBQXpDLElBQUEscUNBQXFCLEVBQUMsRUFBRSxPQUFPLEVBQUUsSUFBSSxFQUFFLENBQUM7c0NBQThCO0FBUjVELE9BQU87SUFEbkIsSUFBQSw2QkFBYSxFQUFDLGFBQWEsQ0FBQztHQUNoQixPQUFPLENBd0JuQjtBQXhCWSwwQkFBTyJ9